module Eseebase {
    export interface IActionButtonScope extends ng.IScope {
        openerClick: Function;
        isActive: boolean;
        ngModel: ActionButtonMenu;
        menuItemClick: Function;
    }

    export class ActionButtonDirective {
        public link: (scope: IActionButtonScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public templateUrl = '/app/directives/action-button.html';
        public scope = {
            ngModel: '='
        };
        public restrict = 'E';
        public require: string;
        public replace: any;
        private static windowEventAttached: boolean;

        constructor(private $timeout: ng.ITimeoutService) {
            ActionButtonDirective.prototype.replace = 'true';
            ActionButtonDirective.prototype.scope = { ngModel: '=' };
            ActionButtonDirective.prototype.link = (scope: IActionButtonScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {
                scope.isActive = false;
                element.click((evt) => {
                    if (evt == null) {
                        return;
                    }
                    evt.stopPropagation();
                    evt.preventDefault();
                });

                element.click((evt) => {
                    if (evt == null) {
                        return;
                    }
                    evt.stopPropagation();
                    evt.preventDefault();
                });

                scope.openerClick = (evt) => {
                    scope.isActive = !scope.isActive;
                }

                scope.menuItemClick = (item: ActionButtonMenuItem, $event: any) => {
                    if ($event != null && $event.target.tagName.toLowerCase() == 'a') {
                        scope.isActive = false;
                        item.active = !item.active;
                    }
                    item.action(item);
                }

                function closeMenu(evt) {
                    $timeout(() => {
                        scope.isActive = false;
                    });
                }

                window.addEventListener('click', closeMenu, false);

                scope.$on('$destroy', function () {
                    window.removeEventListener('click', closeMenu, false);
                })
            };
            
        }

        public static Factory() {
            var directive = ($timeout: ng.ITimeoutService) => {
                return new ActionButtonDirective($timeout);
            };

            directive['$inject'] = ['$timeout'];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('actionButton', ActionButtonDirective.Factory());

    export class ActionButtonMenu {
        public items: ActionButtonMenuItem[];         
    }

    export class ActionButtonMenuItem {
        constructor(public text: string, public active: boolean, public action: Function) {
        }

    }
}

